import React, { useState } from 'react';
import {
  Button, Col, Container, Icons, Row,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import TabMenu from '../../../components/base/TabMenu/TabMenu';
import Grid from '../../../components/base/Grid/Grid';

export default function NotificationTemplateHelper(props) {
  const {
    close = () => {},
    templateHelperData = {},
  } = props;
  const [selectedTab, setSelectedTab] = useState(1);
  const columns = [
    {
      dataField: 'key',
      text: 'Ключ',
      disableSort: true,
    },
    {
      dataField: 'label',
      text: 'Название',
      disableSort: true,
    },
    {
      dataField: 'example',
      text: 'Пример',
      disableSort: true,
    },
  ];
  const list = selectedTab === 1 ? templateHelperData?.vars || [] : templateHelperData?.directives || [];
  return (
    <Dialog
      className="notification-template-helper"
      onClose={close}
      open
    >
      <DialogTitle header="Просмотр справочника" title={<Icons onClick={close} customIcon icon="close" className="close" />} />
      <DialogContent className="application-denied-content">
        <Container className="application-denied-content">
          <TabMenu options={[{ value: 1, label: 'Переменные' }, { value: 2, label: 'Директивы' }]} onSelectOptions={i => setSelectedTab(i.value)} selectedTab={selectedTab} />
          <Grid data={list} columns={columns} />
        </Container>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-buttons">
          <Button className="hff-clear-data" variant="secondary" onClick={close}>Закрыть</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
